import { useLocation } from "react-router-dom";
import { getModelsGroupIdByCollectionId, getRestrictionByCategory } from "../../redux/selectors/ui.selector";
import { useAppSelector } from "../../utils/hooks";
import { filterArrayByRestrictions } from "../../utils/restriction/restrictionUtils";
import { CustomizedState } from "../Player/Player";
import { StandartOptionsWrapSlider } from "../StandartOptionsWrapSlider/StandartOptionsWrapSlider";
import s from "./StandartModelsListGroup.module.scss";

export default function StandartModelsListGroup({ ...props }) {
  const { title, subtitle, values } = props;
  const isPresetsModels = title.includes("presets") || title.includes("bestsellers");
  const locationState = useLocation().state as CustomizedState;
  let getModelsGroupId = "AdditionalItems";

  if (locationState) {
    getModelsGroupId = useAppSelector((state) => getModelsGroupIdByCollectionId(state)(locationState.collectionId));
  }
  const isShowHideOptions = getModelsGroupId === "AdditionalItems";
  const itemsToShow = title.includes("bestsellers") ? 1 : 4;

  const categoryRestriction = useAppSelector(getRestrictionByCategory);

  const filteredCollections = categoryRestriction
    ? filterArrayByRestrictions(values, categoryRestriction, "subcategory")
    : values;

  return (
    <div className={s.preElection}>
      <div className={s.title}>{title}</div>
      <div className={s.subtitle}>{subtitle}</div>
      <StandartOptionsWrapSlider
        values={filteredCollections}
        presetModels={isPresetsModels}
        link={true}
        id={getModelsGroupId}
        isShowHideOptions={isShowHideOptions}
        itemsToShow={itemsToShow}
      />
    </div>
  );
}
